/**
 * HiddenField -- holds a value in form state without rendering UI.
 * Used for auto-populated credential fields like account_ids.
 */
import type { DynamicFieldProps } from './index';

export function HiddenField(_props: DynamicFieldProps) {
  return null;
}
